import { FC, useState, useEffect } from "react";
import { withCdnUrl } from "@smile2impress/attraction-utils";
import Head from "next/head";
import Script from "next/script";

import { COOKIES } from "constants/enum";
import { getAppMode } from "utils/getAppMode";
import { getCookiesValueByName } from "utils/cookie";

export const HeadScripts: FC = () => {
    const { isLiveMode, isPreliveMode } = getAppMode();

    const [isFunctionalActive, setIsFunctionalActive] = useState(false);

    useEffect(() => {
        setIsFunctionalActive(
            getCookiesValueByName(COOKIES.IS_FUNCTIONAL_COOKIE_ACTIVE) === "1"
        );
    }, []);

    return (
        <>
            <Head>
                <meta charSet="utf-8" />
                <meta
                    name="viewport"
                    content="initial-scale=1.0, width=device-width"
                />
                <link
                    rel="apple-touch-icon"
                    type="image/png"
                    sizes="180x180"
                    href={withCdnUrl("/images/fav/apple-touch-icon.png")}
                />
                <link
                    rel="icon"
                    type="image/svg+xml"
                    href={withCdnUrl("/images/fav/favicon.svg")}
                />
                <link
                    rel="icon"
                    type="image/x-icon"
                    sizes="32x32"
                    href={withCdnUrl("/images/fav/favicon.ico")}
                />
                <link
                    rel="icon"
                    type="image/png"
                    sizes="48x48"
                    href={withCdnUrl("/images/fav/favicon-48x48.png")}
                />
                <link rel="manifest" href={withCdnUrl("/site.webmanifest")} />
                <meta name="msapplication-TileColor" content="#00aba9" />
                <meta name="theme-color" content="#ffffff" />
                {/* og:image, keywords — in MetaTags (default + CMS override) */}
                {/* GTM for tests on prelive*/}
                {isPreliveMode && (
                    <>
                        <script
                            id="google-consent"
                            src={withCdnUrl("/scripts/google-consent.js")}
                        />
                        <script
                            id="google-tag-test"
                            async
                            src={withCdnUrl("/scripts/google-tag-test.js")}
                        />
                    </>
                )}
                {isLiveMode && (
                    <>
                        <script
                            id="google-consent"
                            src={withCdnUrl("/scripts/google-consent.js")}
                        />
                        <script
                            id="google-tag"
                            async
                            src={withCdnUrl("/scripts/google-tag.js")}
                        />
                        {/* End Google Tag Manager */}
                    </>
                )}
            </Head>
            {/* Outside <Head>: rendered client-only (cookie gate). Inside next/head it changes the SSR vs client child count and duplicates head tags (canonical). */}
            {isLiveMode && isFunctionalActive && (
                <Script
                    id="beansid-script"
                    src="https://cdn.studentbeans.com/third-party/all.js"
                    strategy="afterInteractive"
                />
            )}
        </>
    );
};
